import Usuario from "../model/usuario/Usuario";

function obterUsuarioAtualStorage() {
  var usuario = localStorage.getItem("usuario-portal");

  if (usuario) {
    usuario = atob(usuario);
    return new Usuario(JSON.parse(usuario));
  }
  return undefined;
}

function salvarUsuarioNaStorage(usuario) {
  usuario = btoa(JSON.stringify(usuario));
  localStorage.setItem("usuario-portal", usuario);
}

function obterEmbedTokenNaStorage(reportId) {
  let tokens = localStorage.getItem("tokens-portal");
  tokens = (!tokens) ? [] : JSON.parse(atob(tokens));

  return tokens.find(t => t.reportId == reportId);
}

function salvarEmbedTokenNaStorage(token) {

  let tokens = localStorage.getItem("tokens-portal");
  tokens = (!tokens) ? [] : JSON.parse(atob(tokens));

  let index = tokens.findIndex(t => t.reportId == token.reportId);

  if (index >= 0) {
    tokens.splice(index, 1, token);
  }else{
    tokens.push(token);
  }

  localStorage.setItem("tokens-portal", btoa(JSON.stringify(tokens)));
}

function removerAutenticacao() {
  localStorage.removeItem("tokens-portal");
  localStorage.removeItem("usuario-portal");
}

export default {
  obterUsuarioAtualStorage,
  salvarUsuarioNaStorage,
  obterEmbedTokenNaStorage,
  salvarEmbedTokenNaStorage,
  removerAutenticacao,
};
